import { render, staticRenderFns } from "./solutionadmi.vue?vue&type=template&id=48d111c0&scoped=true&"
import script from "./solutionadmi.vue?vue&type=script&lang=js&"
export * from "./solutionadmi.vue?vue&type=script&lang=js&"
import style0 from "./solutionadmi.vue?vue&type=style&index=0&id=48d111c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d111c0",
  null
  
)

export default component.exports